import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "94vw",
    ...shorthands.padding("60px", "18px", "20px", "18px"),
    "@media (min-width: 500px)": {
      width: "60%",
      ...shorthands.padding("28px", "18px", "20px", "28px"),
    },
    "@media (max-width: 499px)": {
      paddingRight: "0px",
    },
  },
  orderNumberContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "left",
    ...shorthands.gap("12px"),
    backgroundColor: tokens.colorBrandForeground1,
    ...shorthands.padding("12px"),
    height: "48px",
    ":first-child": {
      ...shorthands.borderRadius("4px", "4px", "0px", "0px"),
    },
    ":last-child": {
      ...shorthands.borderRadius("0px", "0px", "4px", "4px"),
      ...shorthands.borderBottom("none"),
    },

    boxShadow: tokens.shadow4,
  },
  red: {
    backgroundColor: tokens.colorPaletteRedBackground3,
  },
  srOnly: {
    ...shorthands.borderRadius("0px"),
    clip: "rect(0 0 0 0)",
    height: "1px",
    ...shorthands.margin("-1px"),
    ...shorthands.overflow("hidden"),
    ...shorthands.padding("0px"),
    position: "absolute",
    width: "1px",
    whiteSpace: "nowrap",
  },
  orderStatusContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    ...shorthands.gap("2px"),

    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.padding("2px"),

    height: "155px",

    boxShadow: tokens.shadow4,
  },
  pickupLocationContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    ...shorthands.gap("12px"),

    backgroundColor: tokens.colorPalettePurpleBackground2,
    ...shorthands.padding("12px"),
    ":first-child": {
      ...shorthands.borderRadius("4px", "4px", "0px", "0px"),
    },
    ":last-child": {
      ...shorthands.borderRadius("0px", "0px", "4px", "4px"),
      ...shorthands.borderBottom("none"),
    },
    ":only-child": {
      ...shorthands.borderRadius("4px"),
      ...shorthands.borderBottom("none"),
    },
    boxShadow: tokens.shadow4,
  },

  regular: {
    fontWeight: tokens.fontWeightRegular,
  },
  text: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase400,
    fontStyle: "normal",
    overflowWrap: "break-word",
    ...shorthands.overflow("hidden"),
    maxWidth: "calc(100vw - 48px)",
    color: "#242424",
  },
  regularText: {
    fontFamily: tokens.fontFamilyBase,
    fontSize: tokens.fontSizeBase300,
    fontStyle: "normal",
    fontWeight: tokens.fontWeightRegular,

    ...shorthands.overflow("hidden"),
    maxWidth: "calc(100vw - 48px)",
  },
  root: {
    color: "#FFFFFF",
  },
  indicator: {
    width: "20px",
    height: "20px",
    backgroundColor: tokens.colorBrandForeground1,
  },
  checkboxContainer: {
    height: "10px",
    width: "25px",
    alignItems: "center",
    backgroundColor: "pink",
  },
  centered: {
    alignItems: "center",
    width: "75%",
    top: "50%",
    ...shorthands.margin("auto"),
  },

  white: {
    color: tokens.colorNeutralBackground1,
  },
  purple: {
    color: tokens.colorBrandForeground1,
  },
  purpleSeparator: {
    "::before": {
      borderTopWidth: "2px",
      ...shorthands.borderColor(tokens.colorBrandForeground1),
    },
    "::after": {
      borderTopWidth: "2px",
      ...shorthands.borderColor(tokens.colorBrandForeground1),
    },
  },
  graySeparator: {
    "::before": {
      borderTopWidth: "2px",
      ...shorthands.borderColor(tokens.colorNeutralBackground3Pressed),
    },
    "::after": {
      borderTopWidth: "2px",
      ...shorthands.borderColor(tokens.colorNeutralBackground3Pressed),
    },
  },
  orderRightSection: {
    display: "inline-block",
    ...shorthands.margin("auto"),
    width: "100%",
  },
  orderIconSection: {
    display: "inline-block",
    textAlign: "left",
    ...shorthands.margin("auto"),
    width: "8%",
  },
  orderProblemTextSection: {
    display: "inline-block",
    textAlign: "left",
    width: "98%",

    marginLeft: "5%",
    paddingTop: "5px",
  },
  orderNumberSection: {
    display: "inline-block",
    textAlign: "left",
    paddingLeft: "6px",
    ...shorthands.margin("auto"),
    width: "92%",
  },
  orderTimelineContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
  },
  orderPickedUpBox: {
    display: "flex",
    flexDirection: "column",
    width: "92%",
    marginTop: "10px",
    "&:hover": {
      backgroundColor: "#5432E6",
    },
  },
  orderResolvedBox: {
    display: "flex",
    flexDirection: "column",
    width: "92%",
    marginTop: "25px",
    backgroundColor: tokens.colorPaletteRedBackground3,
  },
  orderTimelineTextContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginLeft: "5%",
    paddingTop: "4px",
  },
  orderTimelineSection: {
    alignItems: "center",
    top: "50%",
    ...shorthands.margin("auto"),
    width: "95%",
  },
  icon: {
    width: "24px",
    height: "24px",
  },
  subTitle: {
    display: "none",
    "@media (min-width: 500px)": {
      display: "block",
      fontSize: "20px",
    },
  },
  orderDate: {
    maxWidth: "70vw",
    color: tokens.colorNeutralForeground4,
    display: "none",
    "@media (min-width: 500px)": {
      display: "block",
    },
  },
  orderContainer: {
    display: "flex",
    flexDirection: "column",
    "@media (min-width: 500px)": {
      ...shorthands.padding("24px", "18px", "20px", "18px"),
    },
  },
});
